import React from 'react';

import { Modal } from '../Modal/Modal';

const modalParent = document.getElementById('article');

export const CardSection1: React.FC = () => (
  <Modal buttonText="Labeling Guidelines" modalParent={modalParent}>
    <h3>Labeling Guidelines</h3>
    <h4>Instructions</h4>
    <ul>
      <li>
        Unfortunately we can only use the labeling tool one by one. Therefore,
        please notify the team when you start and finish labeling data in the
        chat.
      </li>
      <li>
        To label a text we select and drag the text that contains the mention
        and hit the green bottom “accept”
      </li>
      <li>
        If you did not select any text because it does not contain any mention
        go to the next text also hitting “accept”
      </li>
      <li>
        Below you will find some important annotation rules in order to decide
        whether some text is a mention or not.
      </li>
      <li>
        Don't hesitate in discussing the rules in case you think they are
        unclear or you think we should add a new one.
      </li>
    </ul>

    <h4>Annotation Rules</h4>
    <ul>
      <li>
        A mention in prodigy is not only the direct word (e.g. BR, MDR,
        @MDRAktuell …), it’s the whole phrase with the question or the quote or
        the mention.
      </li>
      <li>
        Only the part in a comment that is really meant as an address to the
        editorial team/ authors is defined as a mention.
        <br />
        <ul>
          <li>
            <i>
              “Ein Dank für all die schönen Sendungen mit ihm! Ruhe in Frieden!
              Mein Beileid an die Hinterbliebenen! Wieder ein Großer Darsteller
              von der Bühne des Lebens abgetreten.”
            </i>
          </li>
          <li>
            Marked as mention:
            <i>Ein Dank für all die schönen Sendungen mit ihm!</i>
          </li>
        </ul>
      </li>
      <li>
        Twitter is an exception to the annotation, as every reply to a tweet
        automatically includes direct addressing of the tweet author and the
        Twitter accounts named in the source tweet
      </li>
      <li>
        Mentions are not presorted in terms of content for the benefit of the
        editors or authors - only in the sense of structural meaningfulness.
        This task must be taken over by editors.
      </li>
      <li>
        mentions are not marked if they are only a reply tweet and do not
        express anything substantial (in the sense of structural meaningfulness)
        directly to the editors / authors, to which editors must respond.
        <br />
        <ul>
          <li>
            <i>@MDRAktuell Da ist Lauterbach Geschichte!</i>
          </li>
        </ul>
      </li>
      <li>
        Answers from the editorial team are not marked as an mention:
        <br />
        <ul>
          <li>
            <i>🙏🖤</i>
          </li>
        </ul>
      </li>
      <li>
        General responses that are a reply to the editor but contain only a
        general comment and no direct address, question, or request for action
        to the responses are not counted as mentions:
        <br />
        <ul>
          <li>
            <i>Was für ein Mist!</i>
          </li>
        </ul>
      </li>
      <li>
        Thanks to the team are mentions
        <br />
        <ul>
          <li>
            <i>Dankeschön fürs Teilen 😍🙌!</i>
          </li>
        </ul>
      </li>
    </ul>
  </Modal>
);

export const CardSection2: React.FC = () => (
  <Modal buttonText="Detailed Data Sources" modalParent={modalParent}>
    <h3>Detailed Data Sources</h3>
    <ul>
      <li>MDR</li>
      <ul>
        <li>Website comments posted on mdr.de articles</li>
        <li>Social Media comments</li>
        <ul>
          <li>Facebook</li>
          <ul>
            <li>
              MDR - Mitteldeutscher Rundfunk, MDR Thüringen, MDR Sachsen-Anhalt,
              MDR Sachsen, MDR AKTUELL, MDR Investigativ, MDR um 4, SPASSZONE,
              Hauptsache Gesund, MDR Garten
            </li>
          </ul>
          <li>Instagram</li>
          <ul>
            <li>
              Mitteldeutscher Rundfunk, MDR Sachsen-Anhalt, MDR Thüringen, MDR
              Sachsen, MDRklärt, Spasszone, MDRinvestigativ, MDR Garten, Youtube
              MDR Mitteldeutscher Rundfunk, Youtube MDR Investigativ, Youtube
              MDR Spasszone
            </li>
          </ul>
          <li>YouTube</li>
          <ul>
            <li>Recap, Riverboat, MDR Garten</li>
          </ul>
          <li>Twitter</li>
          <ul>
            <li>
              MDR Thüringen, MDR Sachsen, MDR Sachsen-Anhalt, MDR presse, MDR
              Aktuell
            </li>
          </ul>
        </ul>
      </ul>
      <li>BR</li>
      <ul>
        <li>Website comments posted on br24.de articles</li>
        <li>Social Media comments</li>
        <ul>
          <li>Facebook</li>
          <ul>
            <li>BR24</li>
          </ul>
        </ul>
      </ul>
    </ul>
  </Modal>
);

export const CardSection3: React.FC = () => (
  <Modal buttonText="Appendix 1: List of prompts" modalParent={modalParent}>
    <h3>List of prompts</h3>
    <h4>
      This is the roster of prompts that were used to generate comments. Note,
      that the articles teaser text was substituted a teaser
    </h4>
    <ul>
      <li>
        Im Folgenden kritisiert ein deutscher AI Kommentator den/die Autor eines
        Nachrichtenartikels.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden kritisiert ein deutscher AI Kommentator einen
        Nachrichtenartikel als unsachlich.\n\nArtikel:
        &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden kritisiert ein deutscher AI Kommentator die Faktengrundlage
        eines Nachrichtenartikel.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden beleidigt ein deutscher AI Kommentator die Redaktion des
        folgenden Artikels.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden lobt ein deutscher AI Kommentator die Redaktion des
        folgenden Beitrags.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden beklagt sich der Leser darüber, dass sein letzter Kommentar
        zum folgenden Artikel nicht veröffentlich wurde.\n\nArtikel:
        &#123;teaser&#125;\nKlage:
      </li>
      <li>
        Im Folgenden beklagt sich der Leser darüber, dass der folgende Artikel
        unprofessionell ist.\n\nArtikel: &#123;teaser&#125;\nKlage:
      </li>
      <li>
        Ein Leser vermutet in beledigenden Worten, dass die Autoren des
        folgenden Artikels bestochen wurden.\n\nArtikel:
        &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Ein jahrelanger Leser macht einen ironische Kommentar darüber, das die
        Qualität der Recherche immer weiter abnimmt. Er verweist dabei auf den
        folgenden Artikel.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Ein jahrelanger Leser beschimpft den Bayerischen Rundfunk massiv und
        zitiert dabei den folgenden Artikel.\n\nArtikel:
        &#123;teaser&#125;\nBeschimpfung:
      </li>
      <li>
        Ein jahrelanger Leser beschimpft den BR massiv und zitiert dabei den
        folgenden Artikel.\n\nArtikel: &#123;teaser&#125;\nBeschimpfung:
      </li>
      <li>
        Ein jahrelanger Leser beschimpft den Mitteldeutschen Rundfunk massiv in
        gebrochenem Deutsch und zitiert dabei den folgenden Artikel.\n\nArtikel:
        &#123;teaser&#125;\nBeschimpfung:
      </li>
      <li>
        Ein jahrelanger Leser beschimpft den MDR massiv in gebrochenem Deutsch
        und zitiert dabei den folgenden Artikel.\n\nArtikel:
        &#123;teaser&#125;\nBeschimpfung:
      </li>
      <li>
        Ein ehemaliger Mitarbeiter schimpft über den Mitteldeutschen Rundfunk
        und zitiert dabei den folgenden Artikel.\n\nArtikel:
        &#123;teaser&#125;\nBeschimpfung:
      </li>
      <li>
        Im Folgenden bedankt sich ein deutscher AI Kommentator ausdrücklich beim
        @MDR für den folgenden Artikels.\n\nArtikel: &#123;teaser&#125;\nDank:
      </li>
      <li>
        Im Folgenden bedankt sich ein deutscher AI Kommentator überschwänglich
        bei der Redaktion des @BR für den folgenden Artikels.\n\nArtikel:
        &#123;teaser&#125;\nDank:
      </li>
      <li>
        Im Folgenden macht ein Leser den BR in einem Kommentar auf die falsche
        Überschrift des folgenden Artikels aufmerksam.\n\nArtikel:
        &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden macht ein Leser den MDR in einem Kommentar auf die
        mangelhafte Rechschreibung im folgenden Artikels aufmerksam.\n\nArtikel:
        &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden macht ein Leser den MDR in einem Kommentar auf die
        mangelhafte Pressefreiheit im folgenden Artikels aufmerksam.\n\nArtikel:
        &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Im Folgenden macht ein Leser den MDR in einem Kommentar auf die
        mangelhafte Pressefreiheit im folgenden Artikels aufmerksam.\n\nArtikel:
        &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Ein Leser spottet in seinem Kommentar für die Mitarbeiter des
        Bayerischen Rundfunks.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
      <li>
        Ein Leser kritisiert in seinem Kommentar für die Verschwendung beim des
        Mitteldeutschen Rundfunk.\n\nArtikel: &#123;teaser&#125;\nKommentar:
      </li>
    </ul>
  </Modal>
);

export const CardSection4: React.FC = () => (
  <Modal buttonText="Appendix 2: Regular Expressions" modalParent={modalParent}>
    <h3>Regular Expressions used for the Baseline approach</h3>
    <ul>
      <li>@MDR[\-|_|\s|,|\:]</li>
      <li>lieber\s+MDR</li>
      <li>
        \"?(Journalist(en)?|Redakteure?|Autor(en)?)\"?[^!\.?,:]+MDR[\-|_|\s]
      </li>
      <li>MDR-(Beitrag|Artikel|Reportage)</li>
      <li>Frage?\san\s(das|den)\sMDR</li>
      <li>MDR[^!\.]*\?</li>
      <li>MDR(-|24|\s)[^!\.?:]+danke</li>
      <li>(werter|verehrter)\sMDR</li>
      <li>Danke\s[^!\.]+MDR(-|\s|$|!)</li>
      <li>MDR[^!\.,:]+(versagt)</li>
      <li>@BR[\-|_|\s|,|\)]</li>
      <li>lieber\s+BR[\-|_|\s|,]</li>
      <li>
        \"?(Journalist(en)?|Redakteure?|Autor(en)?)\"?\sbeim?\sBR[\-|_|\s]
      </li>
      <li>BR[\-|_|\s](Karte)</li>
      <li>BR[\-|_|\s][^!\.]*\?</li>
      <li>Danke\s[^!\.]+BR(-|24|\s|$|!|\:|\.)</li>
      <li>BR(-|24|\s|$|!|\:|\.)[^!\.?:]+danke</li>
      <li>Danke\s[^!\.]+(Beitrag|Artikels?|Recherche|Bericht|Redaktion)</li>
      <li>Autor(in)\s?</li>
      <li>(Autor)[^!\.,:]+(Artikel|Bericht|Report|Text|Beitrag)</li>
      <li>@red</li>
      <li>
        glaub[^!\.,:]+(Artikel|Bericht|Report|Text|Beitrag)[^!\.,:](nicht|kein)
      </li>
      <li>
        (Artikel|Bericht|Report|Text|Beitrag)[^!\.,:]+(informativ|interessant)
      </li>
      <li>
        (informativ|interessant)[^!\.,:]+(Artikel|Bericht|Report|Text|Beitrag)
      </li>
      <li>Überschrift[^!\.,:]+(unpassend|irreführend|blöde|diskriminierend)</li>
      <li>
        (unpassend|irreführend|blöde|diskriminierende)[^!\.,:]+Überschrift
      </li>
      <li>öffentlich\srechtlich</li>
      <li>Netiquette</li>
      <li>Pressefreiheit</li>
      <li>Recherche-Team</li>
    </ul>
  </Modal>
);

export const CardSection5: React.FC = () => (
  <Modal buttonText="User research questionnaire" modalParent={modalParent}>
    <h3>Questionnaire</h3>
    <ul>
      <li>How is your daily workflow regarding comment moderation?</li>
      <li>What insights about the comments would speed up your work?</li>
      <li>
        Do you think it makes sense to detect topics in comments
        (automatically)?
      </li>
      <li>How is your workflow regarding topic detection in comments?</li>
      <li>Which topics do you report?</li>
      <li>How do you report topics and how would you like to?</li>
      <li>In which frequency do you have the topic output?</li>
      <li>
        What do you find most annoying in your work with comments and topics?
      </li>
      <li>
        What takes most of your time in your work with comments and topics?
      </li>
      <li>
        What is the largest advantage, in your opinion, of automated topic
        detection?
      </li>
      <li>How would you improve the existing system?</li>
      <li>What factors do you consider to decide that a topic is trending?</li>
      <li>
        Do you have a document, database or similar where you keep track of what
        topics are trending and the reasons?
      </li>
    </ul>
  </Modal>
);
